import { NgModule } from '@angular/core';

import { AppComponent } from '@app/app.component';
import { CoreModule } from '@app/core/core.module';
import { AuthModule } from '@modules/auth/auth.module';
import { NotFoundModule } from '@modules/not-found/not-found.module';
import { PortalModule } from '@modules/portal/portal.module';
import { AppRoutingModule } from '@app/routing.module';
import { AppStoreModule } from './store/store.module';
import { MaterialModule } from './material/material.module';
import { SharedModule } from './shared/shared.module';
import { ThemeModule } from './theme/theme.module';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    ApmModule,
    AppRoutingModule,
    CoreModule,
    AuthModule,
    PortalModule,
    NotFoundModule,
    AppStoreModule,
    ThemeModule,
    MaterialModule,
    SharedModule,
    LoadingBarHttpClientModule,
    NgxSpinnerModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(service: ApmService) {
    // Agent API is exposed through this apm instance
    const apm = service.init({
      serviceName: 'PortalClienteFrontend',
      serverUrl:
        'https://11f28a8ef8e244bcb7521e3713a2d651.apm.us-east4.gcp.elastic-cloud.com:443',
      environment: environment.name,
    });
  }
}
